import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/shop/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/shop/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/shop/updateById', data)
}
// 修改
export function updateIsRecById (data) {
  return request.post('/business/shop/updateIsRecById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/shop/delete/${id}`)
}

// 详情
export function shopDetail (id) {
  return request.get(`/business/shop/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/shop/delete/batch', {
    params: {
      ids
    }
  })
}

